










import Vue from "vue";

export default Vue.extend({
  name: "QRCode",
  props: {
    text: {
      type: String,
      default: "用微信、QQ、哔哩哔哩手机端扫码参与活动"
    }
  },
  data() {
    return {
      QRCodeBase: "",
      canShow: false
    };
  },
  created() {
    this.initQRCode();
  },
  methods: {
    initQRCode() {
      // eslint-disable-next-line babel/new-cap
      new window.QRCode.toDataURL(location.href, {
        errorCorrectionLevel: "L",
        margin: 1,
        scale: 7,
        color: {
          dark: "#0a0647",
          light: "#ffffff"
        }
      }).then((text) => {
        this.QRCodeBase = text;
        this.canShow = true;
      });
    }
  }
});
